export const DEFAULT_NAV_HISTORY_STORAGE_KEY = 'portal_nav_history_guest';

export const buildUserNavHistoryStorageKey = (userId: string): string => `portal_nav_history_${userId}`;

/** Number of recent pages to display in navigation bar */
export const NAV_HISTORY_DISPLAY_LIMIT = 15;

/** Maximum number of pages that can be pinned (most recent pinned are kept) */
export const NAV_HISTORY_MAX_PINNED = NAV_HISTORY_DISPLAY_LIMIT; //These are kept equal so that user cannot pin more from the nav bar

/** Maximum total entries stored in navigation history */
export const NAV_HISTORY_MAX_ENTRIES = 50;
